import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Box,
  Chip,
  Menu,
  MenuItem,
  Typography,
  Button
} from "@mui/material";
import "./product.scss";
import Label from "../../../components/Label/Label";
import KeyboardArrowDownIcon from "@mui/icons-material/ArrowDropDown";
import KeyboardArrowUpIcon from "@mui/icons-material/ArrowDropUp";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useState } from "react";
import CheckIcon from "@mui/icons-material/Check";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";

export default function ParameterTable({
  data,
  onView,
  tableHeaders,
  openData,
  moreOption,
  handleMenuOption,
  handleApprove
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [openRow, setOpenRow] = useState(null);
  const [expandedSections, setExpandedSections] = useState({});
  const [selectedRow, setSelectedRow] = useState();


  const handleClick = (event, row) => {
    setAnchorEl(event.currentTarget);
    setSelectedRow(row)
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const toggleExpand = (id) => {
    setOpenRow(openRow === id ? null : id);
  };

  const toggleSection = (rowId, section) => {
    setExpandedSections((prev) => ({
      ...prev,
      [rowId]: {
        ...prev[rowId],
        [section]: !prev[rowId]?.[section],
      },
    }));
  };

  return (
    <Box width="100%">
      <TableContainer
        component={Paper}
        overflow="auto"
        className="product-table-container"
        sx={{ scrollbarGutter: "auto" }}
      >
        <Table stickyHeader sx={{ tableLayout: "fixed", width: "100%" }}>
          <TableHead positon="sticky" top={0} className="table-header">
            <TableRow>
              <TableCell className="product-table-header-cell">Manufacturing Site</TableCell>
              <TableCell className="product-table-header-cell">Created On</TableCell>
              <TableCell className="product-table-header-cell">Updated On</TableCell>
              <TableCell className="product-table-header-cell">Updated By</TableCell>
              <TableCell className="product-table-header-cell">Approved On</TableCell>
              <TableCell className="product-table-header-cell">Approved By</TableCell>
              <TableCell className="product-table-header-cell">Approved</TableCell>
              <TableCell className="product-table-header-cell" align="right"
                sx={{ width: "10%", pr: 2 }}>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody
            sx={{
              "& .MuiTableRow-root": { height: 48 },
              "& .MuiTableCell-root": { py: 0.5 },
            }}
          >
            {
              // openData &&

              data?.data?.results?.map((row) => (
                <>
                  <TableRow key={row.site_id}>

                    <TableCell>{row.site_name}</TableCell>
                    <TableCell sx={{ fontSize: 14 }}>{row.created_at}</TableCell>
                    <TableCell sx={{ fontSize: 14 }}>{row.updated_at}</TableCell>
                    <TableCell sx={{ fontSize: 14 }}>{row.updated_by}</TableCell>
                    <TableCell sx={{ fontSize: 14 }}>{row.approved_at}</TableCell>
                    <TableCell sx={{ fontSize: 14 }}>{row.approved_by}</TableCell>
                   <TableCell sx={{ fontSize: 14 }}>   <Button
                      variant="contained"
                      size="small"
                      onClick={() => handleApprove(row)}
                      disabled={row.approve_status === "Approved"}
                      startIcon={
                        row.approve_status === "Pending"
                          ? <HourglassEmptyIcon />
                          : <CheckIcon />
                      }
                      sx={{
                        textTransform: "none",
                        fontWeight: 500,
                        backgroundColor: row.approve_status === "Approved" ? "#2e7d32" : "#0B4C90",
                        "&:hover": {
                          backgroundColor: row.approve_status === "Approved" ? "#256628" : "#08386a",
                        },
                      }}
                    >
                      {row.approve_status === "Approved" ? "Approved" : "Approve"}
                    </Button></TableCell>
                    <TableCell align="right" >
                      <IconButton size="small" onClick={(e) => handleClick(e, row)}>
                        <MoreVertIcon />
                      </IconButton>
                      <Menu
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleClose}
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "right",
                        }}
                        transformOrigin={{
                          vertical: "top",
                          horizontal: "right",
                        }}
                        PaperProps={{
                          sx: {
                            boxShadow: "none",
                            border: "1px solid #ccc",
                            padding: 0,
                            minWidth: "100px",
                            backgroundColor: "transparent",
                          },
                        }}
                        MenuListProps={{
                          sx: {
                            padding: 0,
                            backgroundColor: "white",
                            borderRadius: 0,
                          },
                        }}
                      >
                        {moreOption?.map((option) => (
                          <MenuItem
                            sx={{ py: 0.4 }}
                            key={option}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleClose();
                              handleMenuOption(option, selectedRow);
                            }}
                          >
                            {option}
                          </MenuItem>
                        ))}
                      </Menu>
                    </TableCell>
                  </TableRow>
                </>
              ))
            }
            {!data?.loader && data?.data?.results?.length === 0 && (
              <TableRow>
                <TableCell colSpan={8} align="center">
                  <Label color="textSecondary" text={"No data found"}></Label>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
